import { useState, useEffect } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleFileUpload } from '../Helper/FIleUploaderToS3';
import { FileViewer } from './FileViewer';
import { BackdropLoader } from '../BackdropLoader';
import { ToastEmitter } from '../ToastEmitter';


export const FilePreviewIcon = ({
  currentFile,
  selectedFile = [],
  setSelectedFile,
  name,
  setValue,
  height = '8.75rem',
  width = '8.75rem',
  isDeleteEnabled = true,

}) => {

  const [isLoading, setIsLoading] = useState(false);
  const renderSelectedFiles = async (file) => {
    try {
      setIsLoading(true);
      const uploadedFile = await handleFileUpload(file);
      setValue(name, [...selectedFile, uploadedFile ? uploadedFile[0].fileIdentifier : {}], { shouldValidate: true, shouldDirty: true });
      setSelectedFile((prev) => [...prev || [], uploadedFile ? uploadedFile[0].fileIdentifier : {}]);
    }
    catch (err) {
      ToastEmitter(err.message, 'error')
    }
    finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (currentFile) {
      renderSelectedFiles(currentFile);
    }
  }, [currentFile]);


  const handleDelete = (index) => {
    setSelectedFile((prev) => prev.filter((_, i) => i !== index));
    setValue(name, selectedFile.filter((_, i) => i !== index), { shouldValidate: true, shouldDirty: true });

  };

  return (
    <>
      {isLoading && <BackdropLoader isLoading={isLoading} />}
      {selectedFile && selectedFile[0] &&
        selectedFile.map((item, index) => (
          <div key={index} className="relative flex justify-center " style={{ width: width, height: height }}>
            <FileViewer id={item} width={width} height={height} />
            {isDeleteEnabled &&
              <button
                type="button"
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(index); }}
                className="absolute top-0 right-0  text-white bg-red-500 rounded-full p-1"
              >
                <DeleteIcon />
              </button>
            }
            {/* <button
                onClick={() => handleView(item)}
                className="absolute inset-0  z-10 flex items-center justify-center text-white bg-black bg-opacity-50 rounded-xl"
              >
                <VisibilityIcon />
              </button> */}
          </div>
        ))
      }
    </>
  )

}